module.exports = __webpack_public_path__ + "img/f-facebook.6dc9ecc1.svg";